import { useLocation, useNavigate, useResolvedPath } from "react-router-dom";
import { useAuth } from "src/authentication/hooks/useAuth";
import { ChurchBannerLayout } from "src/core/church/ChurchBannerLayout";
import { Helmet } from "react-helmet";
import { IconUnlink } from "@tabler/icons-react";
import { Button } from "react-daisyui";
import { ButtonLink } from "./ButtonLink";

export const RouteNotFoundScreen = () => {
    const location = useLocation();
    const navigate = useNavigate();

    const path = useResolvedPath(location.pathname);
    const { person } = useAuth();

    return (
        <ChurchBannerLayout columns="one">
            <Helmet>
                <title>Page not found</title>
            </Helmet>

            <section className="rounded-[1.75rem] bg-base-100 p-6 grid gap-3 justify-items-center text-center shadow-sm">
                <IconUnlink className="text-6xl text-primary" />

                <h1 className="text-3xl font-extrabold tracking-tight">Page not found</h1>

                <p className="text-base-content/70 text-pretty">
                    This page doesn't exist, or you don't have permission to see it. Contact the church if you think
                    that's a mistake.
                </p>

                <div className="pt-2 flex flex-wrap gap-2 justify-center">
                    {location.key !== "default" && (
                        <Button color="primary" className="rounded-full" onClick={() => navigate(-1)}>
                            Go back
                        </Button>
                    )}

                    <ButtonLink to="/" className="btn-outline rounded-full">
                        Go home
                    </ButtonLink>
                </div>

                <p className="font-mono text-xs text-base-content/60 pt-4">
                    Path: {path.pathname}
                    <br />
                    For: {person?.id ?? "not authenticated"}
                </p>
            </section>
        </ChurchBannerLayout>
    );
};
